module.exports = __webpack_public_path__ + "static/img/celoscope-detail-8.d5f0f38.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/celoscopepic/celoscope-detail-8.jpg
// module id = iK0P
// module chunks = 52